import { PageLayout } from "shared";
import { StudentCalendar, useAttendance } from "..";
import "../style/attendance.style.css";

export const AttendanceCalender = () => {
  const {
    activeStartDate,
    setActiveStartDate,
    attendanceProgram,
    attendanceProgramSelected,
    datesLoading,
    showMarker,
    getClassess,
    programList,
    validityLoading,
    onProgramChange,
    tileDisabled,
  } = useAttendance({ load: true });

  const subTitle = (
    <p className="attendance-subtitle">
      View your attendance history and stay on track.
    </p>
  );

  return (
    <div className="attendance-container">
      <PageLayout breadcrumb={[{ label: "Attendance" }]} subTitle={subTitle}>
        <StudentCalendar
          activeStartDate={activeStartDate}
          setActiveStartDate={setActiveStartDate}
          attendanceProgram={attendanceProgram}
          attendanceProgramSelected={attendanceProgramSelected}
          datesLoading={datesLoading || validityLoading}
          showMarker={showMarker}
          getClassess={getClassess}
          programList={programList}
          onProgramChange={onProgramChange}
          tileDisabled={tileDisabled}
        />
      </PageLayout>
    </div>
  );
};
